import ReactDOM from "react-dom/client";
import { IntercomProvider } from "react-use-intercom";
import "../../../index.css";
import App from "./App.tsx";
import { initThirdPartyApis } from "./api/third-party.ts";

initThirdPartyApis();

const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <IntercomProvider autoBoot appId={INTERCOM_APP_ID}>
    <App />
  </IntercomProvider>,
);
